import React from 'react';

export const twitterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15">
      <path d="M15.253 4.162c.01.151.01.302.01.454 0 4.605-3.505 9.913-9.913 9.913A9.846 9.846 0 0 1 0 12.964c.28.033.55.044.841.044 1.63 0 3.129-.55 4.326-1.489a3.49 3.49 0 0 1-3.258-2.416c.216.032.432.054.658.054.313 0 .626-.043.917-.119A3.485 3.485 0 0 1 .69 5.618v-.042a3.53 3.53 0 0 0 1.575.442A3.482 3.482 0 0 1 .712 3.116c0-.647.172-1.24.475-1.758A9.904 9.904 0 0 0 8.37 5.004a3.933 3.933 0 0 1-.087-.798A3.483 3.483 0 0 1 11.768.72c1.004 0 1.91.421 2.546 1.1a6.86 6.86 0 0 0 2.211-.84 3.475 3.475 0 0 1-1.531 1.92A6.985 6.985 0 0 0 17 2.36a7.49 7.49 0 0 1-1.747 1.801Z" />
    </svg>
  );
};
